(function () {
  const storageKey = 'cosh_original_attribution';
  const retentionDays = 90;

  const urlParams = new URLSearchParams(window.location.search);

  const attribution = {
    utm_source: urlParams.get('utm_source') || '',
    utm_medium: urlParams.get('utm_medium') || '',
    utm_campaign: urlParams.get('utm_campaign') || '',
    utm_content: urlParams.get('utm_content') || '',
    utm_term: urlParams.get('utm_term') || '',
    gclid: urlParams.get('gclid') || '',
    original_landing_page: window.location.href,
    original_referrer: document.referrer || '',
    captured_at: new Date().toISOString()
  };

  const trackingKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid'
  ];

  const hasTrackingData = trackingKeys.some(function (key) {
    return attribution[key] !== '';
  });

  function getStoredAttribution() {
    try {
      const storedValue = localStorage.getItem(storageKey);

      if (!storedValue) {
        return null;
      }

      const stored = JSON.parse(storedValue);

      if (!stored || !stored.captured_at) {
        return null;
      }

      const capturedTime = new Date(stored.captured_at).getTime();
      const maximumAge = retentionDays * 24 * 60 * 60 * 1000;

      if (
        Number.isNaN(capturedTime) ||
        Date.now() - capturedTime > maximumAge
      ) {
        localStorage.removeItem(storageKey);
        return null;
      }

      return stored;
    } catch (error) {
      return null;
    }
  }

  function saveFirstTouchAttribution() {
    if (!hasTrackingData) {
      return;
    }

    const existingAttribution = getStoredAttribution();

    // Keep the first campaign that brought the visitor to the website.
    if (existingAttribution) {
      return;
    }

    try {
      localStorage.setItem(storageKey, JSON.stringify(attribution));
    } catch (error) {
      // Do nothing if storage is unavailable.
    }
  }

  function getTrackingKeyFromLabel(label) {
    if (!label) {
      return null;
    }

    const normalized = label
      .toLowerCase()
      .replace(/[_-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (normalized.includes('utm source')) {
      return 'utm_source';
    }

    if (normalized.includes('utm medium')) {
      return 'utm_medium';
    }

    if (normalized.includes('utm campaign')) {
      return 'utm_campaign';
    }

    if (normalized.includes('utm content')) {
      return 'utm_content';
    }

    if (normalized.includes('utm term')) {
      return 'utm_term';
    }

    if (normalized.includes('gclid')) {
      return 'gclid';
    }

    return null;
  }

  function populateFormFields() {
    const stored = getStoredAttribution();

    if (!stored) {
      return;
    }

    document
      .querySelectorAll('input[name="_keyLabel"]')
      .forEach(function (keyLabelInput) {
        const form = keyLabelInput.closest('form');

        if (!form) {
          return;
        }

        let labels;

        try {
          labels = JSON.parse(keyLabelInput.value);
        } catch (error) {
          return;
        }

        Object.keys(labels).forEach(function (fieldName) {
          const fieldLabel = labels[fieldName];
          const trackingKey = getTrackingKeyFromLabel(fieldLabel);

          if (!trackingKey) {
            return;
          }

          const field = form.querySelector(
            '[name="' + fieldName + '"]'
          );

          if (!field) {
            return;
          }

          field.value = stored[trackingKey] || '';

          field.dispatchEvent(
            new Event('input', {
              bubbles: true
            })
          );

          field.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );
        });
      });
  }

  saveFirstTouchAttribution();
  populateFormFields();

  const observer = new MutationObserver(function () {
    populateFormFields();
  });

  function startObserver() {
    if (!document.body) {
      return;
    }

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function () {
      observer.disconnect();
    }, 300000);
  }

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startObserver, {
      once: true
    });
  }
})();